import { RefObject } from "react";

import { PINNED_COLUMN_MIN_TABLE_WIDTH } from "ds/components/Table/constants";
import useTableWidth from "ds/components/Table/hooks/useTableWidth";

type UseTableSimpleEffectiveColumnPinningResult = {
  effectiveIsFirstColumnPinned: boolean;
  isPinningEnabled: boolean;
};

const useTableSimpleEffectiveColumnPinning = (
  tableRef: RefObject<HTMLDivElement | null> | undefined,
  isFirstColumnPinned: boolean
): UseTableSimpleEffectiveColumnPinningResult => {
  const tableWidth = useTableWidth(tableRef, true);
  const isPinningEnabled =
    typeof tableWidth === "undefined" || tableWidth >= PINNED_COLUMN_MIN_TABLE_WIDTH;

  return {
    effectiveIsFirstColumnPinned: isFirstColumnPinned && isPinningEnabled,
    isPinningEnabled,
  };
};

export default useTableSimpleEffectiveColumnPinning;
